import Modal from "components/Modal";
import Button from "components/Button";
import ModalCloseButton from "./ModalCloseButton";
import WarningBox from "components/WarningBox";
import { useBillingNavigation } from "v2/pages/billing/hooks/useBillingNavigation";
import { BillingPath } from "v2/pages/billing/BillingPath";


/**
 * Shared guard modal shown when a user with `hasPaymentIssues` reaches a plan-change
 * surface (upgrade modal, downgrade modal, view-all-plans). Routes the user to the
 * billing details tab so they can resolve outstanding invoices.
 */
export default function PaymentIssuesGuardModal() {
  const { goBack, navigate } = useBillingNavigation();

  return (
    <Modal
      className="!max-w-[600px]"
      onClose={goBack}
    >
      <div className="flex items-center justify-between pt-5 pb-2 px-6">
        <h2 className="text-base font-medium text-gray-900">Resolve outstanding invoices</h2>
        <ModalCloseButton onClick={goBack} />
      </div>
      <div className="flex flex-col gap-6 px-6 pt-3 pb-6">
        <WarningBox
          variant="warning"
          title="Plan changes are paused"
          items={[{
            text: (
              <span className="text-sm text-neutral-700">
                You have outstanding invoices. Please settle them before changing your plan.
              </span>
            ),
          }]}
        />
        <div className="flex gap-2">
          <Button
            text="GO TO BILLING DETAILS"
            onClick={() => navigate(`${BillingPath}/details#payment-history`)}
            className="button button-primary flex-1 rounded"
            size="SM"
          />
          <Button
            text="CLOSE"
            onClick={goBack}
            className="button button-secondary flex-1 rounded"
            size="SM"
          />
        </div>
      </div>
    </Modal>
  );
}
